import { find } from 'lodash';

import { dummyRecipe, initialCostValues } from '../../api/dummyData';

export function getInitialIngredients(recipeName) {
  return find(initialCostValues, { recipeName: recipeName }) || dummyRecipe;
}
